import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dcc5f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content main__content" }
const _hoisted_2 = { class: "content__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "content__date" }, "Today tasks", -1))
const _hoisted_4 = { class: "content__records" }
const _hoisted_5 = { class: "record__title" }
const _hoisted_6 = { class: "record__info" }
const _hoisted_7 = { class: "record__text" }
const _hoisted_8 = { class: "record__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "record content__record",
            key: item.id
          }, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(item.desc), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(item.deadLine), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}